/*
 * Div1InputGID.js: This component renders the input field and the Search button for Retail GID.
 */

import React from "react";
import isUsernameValid from "../../utils/isUsernameValid";
import { useApiActivity } from "../../contexts/ApiActivityContext";
import "./Div1InputEmail.css";

const Div1InputGID = ({
  enteredEmail,
  setEnteredEmail,
  Div1SearchButtonClicked,
  setUserInfo,
  setDiv2Visible,
  activeStep,
}) => {
  const { isActive } = useApiActivity();

  const handleInputChange = (event) => {
    setEnteredEmail(event.target.value);
    setUserInfo({});
    setDiv2Visible(false);
  };

  const placeholderText = "Retail GID username";
  const isInputValid = isUsernameValid("retailGID", enteredEmail);

  return (
    <>
      <div
        className={`child-div form-div ${
          activeStep === 1 ? "active-step" : ""
        }`}
      >
        <input
          type="text"
          placeholder={placeholderText}
          value={enteredEmail}
          onChange={handleInputChange}
          onKeyDown={(e) => {
            if (
              e.key === "Enter" &&
              isInputValid &&
              !isActive
            ) {
              Div1SearchButtonClicked();
            }
          }}
        />
        <button
          className={`app-button ${
            isInputValid && !isActive
              ? "button-valid"
              : "button-invalid"
          }`}
          disabled={!isInputValid || isActive}
          onClick={Div1SearchButtonClicked}
        >
          Search
        </button>
      </div>
    </>
  );
};

export default Div1InputGID;
